const quickEntries = [
  {
    icon: "ri-home-5-line",
    tone: "bg-primary-100 text-primary-700",
    title: "主页直达",
    note: "吃瓜17 最新主站地址，优先推荐访问",
    cta: "立即进入主页",
    hot: true,
  },
  {
    icon: "ri-refresh-line",
    tone: "bg-accent-100 text-accent-800",
    title: "备用入口",
    note: "主站不稳定时的备用通道，随时可用",
    cta: "前往备用入口",
    hot: false,
  },
  {
    icon: "ri-link",
    tone: "bg-secondary-200 text-secondary-800",
    title: "地址收藏夹",
    note: "把常用网址收进本页，一次存、随时点",
    cta: "收藏常用网址",
    hot: false,
  },
  {
    icon: "ri-focus-3-line",
    tone: "bg-secondary-200 text-secondary-800",
    title: "更新频道",
    note: "第一时间推送入口变动与内容更新提醒",
    cta: "关注更新动态",
    hot: false,
  },
];

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-background-50">
      {/* 顶部留白拉开“上疏”节奏 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-28 md:pt-36 pb-10 md:pb-14 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 text-accent-800 text-xs font-medium px-3.5 py-1.5">
          <i className="ri-flashlight-line text-sm" />
          吃瓜17 导航 · 常用入口已收录，随点随达
        </span>

        <h1 className="mt-6 mx-auto max-w-3xl font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
          吃瓜17 导航入口，吃瓜17网址地址汇总
        </h1>
        <p className="mt-4 mx-auto max-w-2xl text-sm md:text-base text-foreground-700 leading-relaxed">
          这里整理吃瓜17 导航入口与最新网址链接，供你快速找到主页直达位置。
          把本站收藏为导航书签，下次想访问吃瓜17 资源页面时一键直达，省去反复搜索的麻烦。
        </p>

        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#entries"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-rocket-2-line text-base" />
            直达吃瓜17 官方入口
          </a>
          <a
            href="#guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 text-sm font-semibold text-foreground-800 bg-background-50 border border-secondary-300 hover:bg-secondary-100 transition-colors"
          >
            <i className="ri-book-open-line text-base" />
            看使用帮助
          </a>
        </div>
      </div>

      {/* 首屏“多卡并列”主视觉 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pb-14 md:pb-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {quickEntries.map((q) => (
            <article
              key={q.title}
              className="group rounded-xl border border-secondary-200/70 bg-background-100/60 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-start justify-between">
                <span className={`grid place-items-center w-11 h-11 rounded-lg ${q.tone}`}>
                  <i className={`${q.icon} text-xl`} />
                </span>
                {q.hot && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2 py-0.5 text-[11px] font-medium text-background-50">
                    <i className="ri-fire-line text-xs" /> 热门
                  </span>
                )}
              </div>
              <h3 className="mt-4 text-base md:text-lg font-bold text-foreground-950">{q.title}</h3>
              <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">{q.note}</p>
              <button
                type="button"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap self-start rounded-md px-3 py-1.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors"
              >
                {q.cta}
                <i className="ri-arrow-right-s-line text-base" />
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}